export default __webpack_public_path__ + "static/media/empty_page.dff80055.png";